export const dnldRouteMapping = (builder) => ({
    dnldRouteMapping: builder.mutation({
      query: ({ user_name, search, created_by_userid, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_list_of_routes',
          method: 'GET',
          params: { user_name, search, created_by_userid, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  